import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h5> 404 </h5>
      <p> Not found </p>
    </div>
  );
};

export default NotFound;
